var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useArrowNav } from '../../hooks/useArrowNav';
import { useMergedRef } from '../../hooks';
export const ColorPicker = React.forwardRef((_a, ref) => {
    var { className, colors, value, disabled = false, readonly = false, onChange } = _a, rest = __rest(_a, ["className", "colors", "value", "disabled", "readonly", "onChange"]);
    const handleItemClick = (color) => () => {
        if (!disabled && !readonly && color !== value && onChange) {
            onChange(color);
        }
    };
    const arrowNavRef = React.useRef(null);
    const mergedRef = useMergedRef(ref, arrowNavRef);
    useArrowNav({
        disabled: disabled || readonly,
        scope: arrowNavRef,
        handleY: false,
        focusableSelector: { selector: 'button' },
        onKeyDown: (e, data) => { var _a; return (_a = data.next) === null || _a === void 0 ? void 0 : _a.click(); },
    });
    return (React.createElement("div", Object.assign({}, rest, { className: classnames('ColorPicker', className, {
            'ColorPicker--disabled': disabled,
        }), ref: mergedRef, role: "radiogroup", "data-anvil-component": "ColorPicker" }), colors.map((color, index) => (React.createElement("button", { key: index, className: classnames('ColorPicker__Item', {
            'ColorPicker__Item--active': color === value,
        }), style: { backgroundColor: color }, onClick: handleItemClick(color), role: "radio", "aria-label": color, "aria-checked": color === value, tabIndex: disabled || readonly ? -1 : null })))));
});
//# sourceMappingURL=ColorPicker.js.map